import { z } from 'zod'

const descriptionSchema = z.object({
	description: z.string().trim().min(10, 'Не менее 10 символов (пробелы по краям не считаются)').max(400)
}) 

export default descriptionSchema